import { ImprovementPlanComponent } from './improvement-plan/components/get-improvement-plan/improvement-plan.component';
import { EmailContactComponent } from './email-contact/components/get-email-contacts/email.contact.component';
import { ContactComponent } from './contacts/components/get-email-contacts/contact.component';
import { BenefeciariesComponent } from './beneficiaries/components/get-beneficiaries/benefeciaries.component';
import { QuestionsComponent } from './questions/components/get-questions/questions.component';
import { ServiceDetailComponent } from './services/components/service-detail/service-detail.component';
import { ServicesComponent } from './services/components/get-services/services.component';
import { RouterModule, Routes } from '@angular/router';
import { NgModule, Component } from '@angular/core';
import { AdministrationComponent } from './administration.component';
import { PoliciesComponent } from './policies/components/get-policies/policies.component';
import { HomeComponent } from './home/components/get-home/home.component';
import { ServiceTypeComponent } from './services-type/components/get-service-types/service-type.component';
import { ImprovementPlanProcessComponent } from '../shared/Components/improvement-plan/improvement-plan-process/improvement-plan-process.component';
import { MahakImprovementPlanComponent } from '../shared/Components/improvement-plan/mahak-improvement-plan/mahak-improvement-plan';
import { AboutComponent } from './about/components/add-about/about.component';
import { GetManagementsComponent } from './management-info/components/get-managements/get-managements.component';
import { GetNewsComponent } from './news/components/get-news/news.component';
import { patch } from '@nebular/theme';
import { GetEventsComponent } from './events/components/get-events/events.component';
import { GetBlogsComponent } from './blogs/components/get-blogs/blogs.component';
import { GetBoardOfTrusteesComponent } from './board-of-trustees/components/get-board-of-trustees/get-board-of-trustees.component';
import { GetCommittesComponent } from './committees/compoennts/get-committes/get-committes.component';
import { GetLibrariesComponent } from './libraries/components/get-libraries/get-libraries.component';
import { GetRegulationsComponent } from './regulations/components/get-regulations/get-regulations.component';
import { GetAcheivementsComponent } from './achievements/components/get-acheivements/get-acheivements.component';
import { GetReportsComponent } from './reports/components/get-reports/get-reports.component';
import { GetCooperationComponent } from './cooperation/components/get-cooperation/get-cooperation.component';
import { GetUsersComponentComponent } from './users/components/get-users-component/get-users-component.component';
import { GetRolesComponentComponent } from './roles/components/get-roles-component/get-roles-component.component';
import { GetComplexAttachementsComponent } from './complex-attachements/components/get-complex-attachements/get-complex-attachements.component';
import { GetDspaceComponent } from './dspace/components/get-dspace/get-dspace.component';
import { GetDspaceStatisticsComponent } from './dspace-statistics/components/get-dspace-statistics/get-dspace-statistics.component';
import { GetComplexInfoComponent } from './complex-info/components/get-complex-info/get-complex-info.component';
import { GetEmergencyCallsComponent } from './emergency-calls/components/get-emergency-calls/get-emergency-calls.component';
import { GetVisitTypesComponent } from './complex-visit-types/components/get-visit-types/get-visit-types.component';
import { GetPartnerComponent } from './partners/components/get-partner/get-partner.component';
import { GetAppInfoComponent } from './app-info/components/get-app-info/get-app-info.component';
import { GetCentersComponent } from './Centers/Components/get-centersdetails/get-centersdetails.component';
import { GetPortalsDetailsComponent } from './Portals/Components/get-portals/get-portals.component';
import { GetInstitutionsComponent } from './Institution/Components/get-institution/get-institution.component';
import { GetUserProfileComponent } from './ProfileInfo/Components/get-user-profile/get-user-profile.component';
import { GetPageRolesComponent } from './PageRoles/Components/get-page-roles/get-page-roles.component';
import { GetElectronicSharingComponent } from './electronic-sharing/components/get-electronic-sharing/get-electronic-sharing.component';
import { GetElectronicConsultationComponent } from './electronic-consultation/components/get-electronic-consultation/get-electronic-consultation.component';
import { GetOpenDataComponent } from './open-data/components/get-open-data/get-open-data.component';
import { GetContactUsMessagesComponent } from './contact-us-messages/components/get-contact-us-messages/get-contact-us-messages.component';
import { GetRequestLoggingsComponent } from './request-logging/components/get-request-loggings/get-request-loggings.component';
import { DeleteConfirmationComponent } from './delete-confirmation/delete-confirmation.component';
const routes: Routes = [
  {
    path: '',
    component: AdministrationComponent,
    children: [
      {
        path: '',
        component: HomeComponent,
      },
      {
        path: 'about',
        component: AboutComponent,
      },
      {
        path: 'managements',
        component: GetManagementsComponent,
      },
      {
        path: 'news',
        component: GetNewsComponent,
      },
      {
        path: 'events',
        component: GetEventsComponent,
      },
      {
        path: 'electronic-sharing',
        component: GetElectronicSharingComponent,
      },
      {
        path: 'electronic-consultation',
        component: GetElectronicConsultationComponent,
      },
      {
        path: 'open-data',
        component: GetOpenDataComponent,
      },
      {
        path: 'blogs',
        component: GetBlogsComponent,
      },
      {
        path: 'board-of-trustees',
        component: GetBoardOfTrusteesComponent,
      },
      {
        path: 'committees',
        component: GetCommittesComponent,
      },
      {
        path: 'libraries',
        component: GetLibrariesComponent,
      },
      {
        path: 'regulations',
        component: GetRegulationsComponent,
      },
      {
        path: 'achievements',
        component: GetAcheivementsComponent,
      },
      {
        path: 'reports',
        component: GetReportsComponent,
      },
      {
        path: 'cooperations',
        component: GetCooperationComponent,
      },
      {
        path: 'services',
        component: ServicesComponent,
      },
      {
        path: 'services-detail/:id',
        component: ServiceDetailComponent,
      },
      {
        path: 'questions',
        component: QuestionsComponent,
      },
      {
        path: 'policies',
        component: PoliciesComponent,
      },
      {
        path: 'partners',
        component: GetPartnerComponent,
      },
      {
        path: 'services-types',
        component: ServiceTypeComponent,
      },
      {
        path: 'benefeciaries',
        component: BenefeciariesComponent,
      },
      {
        path: 'contact',
        component: ContactComponent,
      },
      {
        path: 'email-contact',
        component: EmailContactComponent,
      },
      {
        path: 'plan/:id/:type',
        component: MahakImprovementPlanComponent,
      },
      {
        path: 'users',
        component: GetUsersComponentComponent,
      },
      {
        path: 'roles',
        component: GetRolesComponentComponent,
      },
      {
        path: 'complex-attachements',
        component: GetComplexAttachementsComponent,
      },
      {
        path: 'dspace',
        component: GetDspaceComponent,
      },
      {
        path: 'dspace-statistics',
        component: GetDspaceStatisticsComponent,
      },
      {
        path: 'complex-info',
        component: GetComplexInfoComponent,
      },
      {
        path: 'emergency-calls',
        component: GetEmergencyCallsComponent,
      },
      {
        path: 'visit-types',
        component: GetVisitTypesComponent,
      },
      {
        path: 'app-info',
        component: GetAppInfoComponent,
      },
      {
        path: 'portals',
        component: GetPortalsDetailsComponent,
      },
      {
        path: 'workflow',
        loadChildren: () => import('../workFlowModule/work-flow/work-flow.module').then((a) => a.WorkFlowModule),
      },
      {
        path: 'dynamicForms',
        loadChildren: () => import('../DynamicFormsModule/dynamicForms.module').then((a) => a.DynamicFormsModule),
      },
      {
        path: 'centers',
        component: GetCentersComponent,
      },
      {
        path: 'institutions',
        component: GetInstitutionsComponent,
      },
      {
        path: 'pages-role',
        component: GetPageRolesComponent,
      },
      {
        path: 'user-profile',
        component: GetUserProfileComponent,
      },
      {
        path: 'contact-us-messages',
        component: GetContactUsMessagesComponent,
      },
      {
        path: 'request-logging',
        component: GetRequestLoggingsComponent,
      },
      {
        path:'delete-confirmation',
        component:DeleteConfirmationComponent
      }

    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdministrationRoutingRoutingModule {}
